import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { post } from "../../../helpers/api_helper";
import { triggerToast } from "../../../utils/toast";
import { blogApiUrl } from "../../../utils/variables";

const NewsletterModal = ({ show, handleClose }) => {
    const [subscriberName, setSubscriberName] = useState("");
    const [subscriberEmail, setSubscriberEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!subscriberEmail) {
            triggerToast("Please fill in all fields", "error");
            return;
        }

        setLoading(true);
        try {
            const response = await post(`${blogApiUrl}/newsletter/subscribe`, {
                name: subscriberName,
                email: subscriberEmail,
            });
            console.log(response)
            if (response.status === 201 || response.status === 200) {
                triggerToast(response.message || "Subscribed successfully!", "success");
                const currentUserEmail = localStorage.getItem('userEmail') || 'guest'
                localStorage.setItem(`has_seen_newsletter_popup_${currentUserEmail}`, "true");
                handleClose();
            } else {
                triggerToast(response.message || "Subscription completed", "success");
                const currentUserEmail = localStorage.getItem('userEmail') || 'guest'
                localStorage.setItem(`has_seen_newsletter_popup_${currentUserEmail}`, "true");
                handleClose();
            }
        } catch (error) {
            console.error("Newsletter submission error:", error);
            triggerToast(error?.response?.data?.error || error?.response?.data?.message || "Something went wrong. Please try again.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleDismiss = () => {
        const currentUserEmail = localStorage.getItem('userEmail') || 'guest'
        localStorage.setItem(`has_seen_newsletter_popup_${currentUserEmail}`, "true");
        handleClose();
    };

    return (
        <Modal
            show={show}
            onHide={handleDismiss}
            centered
            backdrop="static"
            keyboard={false}
            dialogClassName="newsletter-modal-proper-dialog"
        >
            <div
                style={{
                    background: "#1C1D26",
                    color: "#fff",
                    borderRadius: "16px",
                    padding: "24px 30px",
                    position: "relative",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.6)",
                    width: "550px",
                    maxWidth: "95vw",
                    margin: "0 auto",
                }}
            >
                <button
                    onClick={handleDismiss}
                    style={{
                        position: "absolute",
                        top: "16px",
                        right: "20px",
                        background: "transparent",
                        border: "none",
                        color: "rgba(255, 255, 255, 0.4)",
                        fontSize: "24px",
                        cursor: "pointer",
                        lineHeight: 1,
                        transition: "color 0.2s ease",
                        zIndex: 10,
                    }}
                    onMouseOver={(e) => (e.target.style.color = "rgba(255, 255, 255, 0.8)")}
                    onMouseOut={(e) => (e.target.style.color = "rgba(255, 255, 255, 0.4)")}
                >
                    &times;
                </button>

                <div style={{ textAlign: "center", marginBottom: "20px" }}>
                    <h2
                        style={{
                            fontSize: "22px",
                            fontWeight: "700",
                            marginBottom: "6px",
                            background: "linear-gradient(90deg, #F6255A 0%, #FF6B95 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }}
                    >
                        Subscribe to Newsletter
                    </h2>
                    <p style={{ color: "rgba(255, 255, 255, 0.6)", fontSize: "14px", margin: 0 }}>
                        Get the latest insights and trends delivered directly to your inbox.
                    </p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div style={{ display: 'flex', gap: '15px', marginBottom: '20px' }}>

                        <div style={{ flex: 1 }}>
                            <label style={{ display: "block", marginBottom: "6px", fontSize: "12px", color: "rgba(255, 255, 255, 0.5)", fontWeight: "500" }}>
                                Email
                            </label>
                            <input
                                type="email"
                                value={subscriberEmail}
                                onChange={(e) => setSubscriberEmail(e.target.value)}
                                placeholder="Email Address"
                                style={{
                                    width: "100%",
                                    padding: "10px 14px",
                                    borderRadius: "8px",
                                    background: "rgba(255, 255, 255, 0.04)",
                                    border: "1px solid rgba(255, 255, 255, 0.1)",
                                    color: "#fff",
                                    fontSize: "14px",
                                    outline: "none",
                                }}
                                required
                            />
                        </div>
                    </div>

                    <div style={{ textAlign: "center" }}>
                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                width: "200px",
                                padding: "12px",
                                borderRadius: "8px",
                                background: "linear-gradient(90deg, #F6255A 0%, #F15A7F 100%)",
                                color: "#fff",
                                border: "none",
                                fontSize: "14px",
                                fontWeight: "600",
                                cursor: loading ? "not-allowed" : "pointer",
                                transition: "all 0.2s ease",
                                boxShadow: "0 4px 12px rgba(246, 37, 90, 0.25)",
                                marginBottom: "12px"
                            }}
                            onMouseOver={(e) => {
                                if (!loading) {
                                    e.target.style.transform = "translateY(-1px)";
                                    e.target.style.boxShadow = "0 6px 16px rgba(246, 37, 90, 0.35)";
                                }
                            }}
                            onMouseOut={(e) => {
                                if (!loading) {
                                    e.target.style.transform = "translateY(0)";
                                    e.target.style.boxShadow = "0 4px 12px rgba(246, 37, 90, 0.25)";
                                }
                            }}
                        >
                            {loading ? "Subscribing..." : "Subscribe Now"}
                        </button>
                        <p style={{ margin: 0, fontSize: "11px", color: "rgba(255, 255, 255, 0.35)", fontWeight: "400" }}>
                            * Unsubscribe at any time. We respect your privacy.
                        </p>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default NewsletterModal;
